import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Alert,
	Box,
	Button,
	Divider,
	IconButton,
	List,
	ListItem,
	ListItemIcon,
	ListItemText,
	Menu,
	MenuItem,
	MenuList,
	Paper,
	TextField,
	Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { deleteNote, editNotes, getNotes, saveNote } from "../../../../services/NotesApi";

import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import CancelIcon from "@mui/icons-material/Cancel";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useSelector } from "react-redux";
import { logger } from "../../../../utils/logger";
const NotesMenu = ({ boxID, notebookId, handleClose }) => {
	const [notes, setNotes] = useState([]);
	const [editNote, setEditNote] = useState({});
	const [editNoteId, setEditNoteId] = useState(null);
	const [loadingNotes, setLoadingNotes] = useState(true);
	const [showAlert, setShowAlert] = useState(false);
	const [expanded, setExpanded] = useState(false);
	const [anchorEl, setAnchorEl] = useState(null);
	const [newNoteScreen, setNewNoteScreen] = useState("Notes");
	const [menuNoteId, setMenuNoteId] = useState(null);
	const inputRef = useRef();
	const textAreaRef = useRef();
	const { firstName, lastName } = useSelector((state) => state.userDetails);

	const handleClick = (event, noteId) => {
		setMenuNoteId(noteId);
		setAnchorEl(event.currentTarget);
	};
	const handleCloseMenu = (noteId) => {
		setMenuNoteId(null);
		setAnchorEl(null);
	};

	const handleChange = (noteId) => (event, isExpanded) => {
		setExpanded(isExpanded ? noteId : false);
	};

	function getNextNoteId(existingNotes) {
		if (!existingNotes || existingNotes.length === 0) {
			return "A000001"; // Start with A000001 if no notes exist
		}

		// Extract the last note ID from the last object in the list
		const lastNoteId = Object.keys(existingNotes[existingNotes.length - 1])[0];

		// Extract the letter prefix (A-Z)
		let letterPart = lastNoteId[0];

		// Extract the numeric part and increment it
		let numericPart = parseInt(lastNoteId.substring(1), 10) + 1;

		// If the numeric part exceeds 999999, reset it to 000001 and increment the letter
		if (numericPart > 999999) {
			numericPart = 1; // Reset to 000001
			letterPart = String.fromCharCode(letterPart.charCodeAt(0) + 1); // Move to next letter
		}

		// Format new ID with leading zeros in numeric part
		const newNoteId = `${letterPart}${numericPart.toString().padStart(6, "0")}`;

		return newNoteId;
	}
	useEffect(() => {
		const fetchData = async () => {
			setLoadingNotes(true);
			const notes = await getNotes(notebookId, boxID);
			if (notes?.error === "No notes found for the given IDs" || !notes?.data?.length) {
				setShowAlert(true);
			} else {
				setNotes(notes?.data || []);
			}
			setLoadingNotes(false);
		};
		fetchData();
	}, [boxID, notebookId]);

	const saveNewNote = async () => {
		const title = inputRef.current.value;
		const note = textAreaRef.current.value;
		const noteId = getNextNoteId(notes);
		const noteBody = { [noteId]: { title, note } };
		if (title && note) {
			const response = await saveNote(notebookId, boxID, noteBody);
			if (response.error) {
				logger.log("Error saving note:", response.error);
			} else {
				setNotes([...notes, { [noteId]: { title, note } }]);
				inputRef.current.value = "";
				textAreaRef.current.value = "";
				setShowAlert(false);
				setNewNoteScreen("Notes");
			}
		}
	};

	const editNoteHandler = async () => {
		const note = {
			[editNoteId]: {
				title: editNote?.title,
				note: editNote?.data,
			},
		};
		const response = await editNotes(notebookId, boxID, editNoteId, note);
		if (response.error) {
			logger.log("Error editing note:", response.error);
		} else {
			setEditNote({ title: "", data: "" });
			setNotes(response.data?.NOTES);
			setNewNoteScreen("Notes");
		}
	};
	const deleteNoteHandler = async (noteId) => {
		const response = await deleteNote(notebookId, boxID, noteId);
		if (response.error) {
			logger.log("Error deleteing note:", response.error);
		} else {
			setEditNote({ title: "", data: "" });
			if (!response.data?.NOTES.length) setShowAlert(true);
			setNotes(response.data?.NOTES);
		}
	};

	const NoteScreen = () => {
		if (newNoteScreen === "Create New Note") {
			return (
				<React.Fragment>
					<Box>
						<IconButton
							size='small'
							onClick={() => setNewNoteScreen("Notes")}
							sx={{ paddingBottom: "0", color: "#ffffff" }}>
							<ArrowBackIosIcon sx={{ color: "#fff" }} size='small' /> Back
						</IconButton>
					</Box>
					<List sx={{ backgroundColor: "#000000", paddingTop: "0" }}>
						<ListItem sx={{ display: "flex", flexDirection: "column" }}>
							<ListItemText sx={{ textAlign: "start", width: "100%" }}>
								{firstName} {lastName}
							</ListItemText>
							<input
								ref={inputRef}
								type='text'
								style={{
									width: "100%",
									marginTop: "0.5rem",
									borderRadius: "5px",
								}}
								placeholder={"Note Title"}
							/>
							<textarea
								ref={textAreaRef}
								rows='4'
								// cols='50'
								style={{
									width: "100%",
									marginTop: "0.5rem",
									borderRadius: "5px",
								}}
								placeholder={"Add Note"}
								type='text'
							/>
							<Box
								sx={{
									display: "flex",
									flexDirection: "row",
									gap: "0.5rem",
									justifyContent: "flex-end",
									width: "100%",
									paddingTop: "0.5rem",
								}}>
								<Button
									size='small'
									sx={{ color: "#fff" }}
									onClick={() => {
										setNewNoteScreen("Notes");
									}}>
									Cancel
								</Button>
								<Button
									variant='contained'
									onClick={saveNewNote}
									size='small'
									sx={{ backgroundColor: "#FCCB06" }}>
									Save
								</Button>
							</Box>
						</ListItem>
					</List>
				</React.Fragment>
			);
		} else if (newNoteScreen === "Notes") {
			return (
				<List
					sx={{
						maxHeight: "130px",
						overflowY: "auto",
						scrollbarWidth: "none",
						backgroundColor: "#36454F",
					}}
					disablePadding>
					{showAlert ? (
						<ListItem>
							<ListItemText primary='No Notes found.' />
						</ListItem>
					) : (
						notes?.map((note) => {
							const noteId = Object.keys(note)[0];
							const noteData = note[noteId];
							logger.log("NoteData: ", noteData);
							return (
								<React.Fragment key={noteId}>
									<ListItem
										key={noteId}
										disablePadding
										sx={{ alignItems: "start" }}>
										<Accordion
											expanded={expanded === noteId}
											onChange={handleChange(noteId)}
											sx={{
												width: "100%",
												backgroundColor: "transparent",
												boxShadow: "none",
												color: "#fff",
												marginBottom: "0rem !important",
											}}>
											<AccordionSummary
												sx={{
													padding: "0 1rem",
													"& .MuiAccordionSummary-content": {
														margin: "0",
													},
													"& .MuiAccordionSummary-root": {
														minHeight: "fit-content",
													},
												}}
												expandIcon={
													<ExpandMoreIcon sx={{ color: "#fff" }} />
												}
												aria-controls='panel1bh-content'
												id='panel1bh-header'>
												<ListItemText primary={noteData?.title} />
											</AccordionSummary>
											<AccordionDetails>
												<Typography color='white'>
													{noteData?.note}
												</Typography>
											</AccordionDetails>
										</Accordion>

										{/* <ListItemText>{noteData?.["title"]}</ListItemText> */}
										<ListItemIcon
											sx={{ minWidth: "0rem !important" }}
											onClick={(e) => {
												handleClick(e, noteId);
											}}>
											<MoreVertIcon
												fontSize='small'
												sx={{ color: "#fff", cursor: "pointer" }}
											/>
										</ListItemIcon>
										<Menu
											id='basic-menu'
											anchorEl={anchorEl}
											open={menuNoteId === noteId}
											onClose={handleCloseMenu}
											sx={{
												"& .MuiPaper-root": {
													backgroundColor: "#1B1B1B", // Background color of the entire menu
												},
											}}
											MenuListProps={{
												"aria-labelledby": "basic-button",
											}}>
											<MenuItem
												sx={{
													color: "#fff", // White text
													backgroundColor: "#1B1B1B", // Menu item background
													"&:hover": {
														backgroundColor: "#555", // Darker grey on hover
													},
												}}
												onClick={() => {
													handleCloseMenu();
													setNewNoteScreen("Edit Note");
													logger.log(
														"note Title:",
														noteData?.title,
														" Note:",
														noteData?.note
													);
													setEditNote({
														title: noteData?.title,
														data: noteData?.note,
													});
													setEditNoteId(noteId);
												}}>
												Edit
											</MenuItem>
											<MenuItem
												sx={{
													color: "#fff", // White text
													backgroundColor: "#1B1B1B", // Menu item background
													"&:hover": {
														backgroundColor: "#555", // Darker grey on hover
													},
												}}
												onClick={() => {
													deleteNoteHandler(noteId);
													handleCloseMenu();
												}}>
												Delete
											</MenuItem>
										</Menu>
									</ListItem>
									<Divider sx={{ backgroundColor: "#fff" }} />
								</React.Fragment>
							);
						})
					)}
				</List>
			);
		} else if (newNoteScreen === "Edit Note") {
			return (
				<React.Fragment>
					<Box>
						<IconButton
							size='small'
							onClick={() => setNewNoteScreen("Notes")}
							sx={{ paddingBottom: "0", color: "#ffffff" }}>
							<ArrowBackIosIcon sx={{ color: "#fff" }} size='small' /> Back
						</IconButton>
					</Box>
					<List sx={{ backgroundColor: "#000000", paddingTop: "0" }}>
						<ListItem sx={{ display: "flex", flexDirection: "column" }}>
							<ListItemText sx={{ textAlign: "start", width: "100%" }}>
								{firstName} {lastName}
							</ListItemText>
							<input
								value={editNote?.title}
								type='text'
								style={{
									width: "100%",
									marginTop: "0.5rem",
									borderRadius: "5px",
								}}
								placeholder={"Note Title"}
								onChange={(e) =>
									setEditNote({ ...editNote, title: e.target.value })
								}
							/>
							<textarea
								value={editNote?.data}
								rows='4'
								// cols='50'
								style={{
									width: "100%",
									marginTop: "0.5rem",
									borderRadius: "5px",
								}}
								placeholder={"Add Note"}
								type='text'
								onChange={(e) => setEditNote({ ...editNote, data: e.target.value })}
							/>
							<Box
								sx={{
									display: "flex",
									flexDirection: "row",
									gap: "0.5rem",
									justifyContent: "flex-end",
									width: "100%",
									paddingTop: "0.5rem",
								}}>
								<Button
									size='small'
									sx={{ color: "#fff" }}
									onClick={() => {
										setEditNote({ title: "", data: "" });
										setNewNoteScreen("Notes");
									}}>
									Cancel
								</Button>
								<Button
									variant='contained'
									onClick={editNoteHandler}
									size='small'
									sx={{ backgroundColor: "#FCCB06" }}>
									Save
								</Button>
							</Box>
						</ListItem>
					</List>
				</React.Fragment>
			);
		}
	};
	return (
		<>
			{/* {showAlert && (
				<Alert severity='info' color='warning'>
					No Notes found.
				</Alert>
			)} */}
			<Paper sx={{ width: 320, maxWidth: "100%", backgroundColor: "#000", color: "#fff" }}>
				<List sx={{ backgroundColor: "#000000" }}>
					<ListItem>
						<ListItemText>{newNoteScreen}</ListItemText>
						<ListItemIcon
							sx={{ minWidth: "0rem !important" }}
							onClick={() => {
								handleClose();
							}}>
							<CancelIcon fontSize='small' sx={{ color: "#fff" }} />
						</ListItemIcon>
					</ListItem>
				</List>
				<Divider sx={{ backgroundColor: "#fff" }} />
				{loadingNotes ? (
					<Typography sx={{ color: "#fff", textAlign: "center", padding: "10px" }}>
						Loading notes...
					</Typography>
				) : (
					// <List
					// 	sx={{
					// 		maxHeight: "130px",
					// 		overflowY: "auto",
					// 		scrollbarWidth: "none",
					// 		backgroundColor: "#36454F",
					// 	}}
					// 	disablePadding>
					// 	{notes?.map((note) => {
					// 		const noteId = Object.keys(note)[0];
					// 		const noteData = note[noteId];
					// 		console.log("NoteData: ", noteData);
					// 		return (
					// 			<React.Fragment key={noteId}>
					// 				<ListItem
					// 					key={noteId}
					// 					disablePadding
					// 					sx={{ alignItems: "start" }}>
					// 					<Accordion
					// 						expanded={expanded === noteId}
					// 						onChange={handleChange(noteId)}
					// 						sx={{
					// 							width: "100%",
					// 							backgroundColor: "transparent",
					// 							boxShadow: "none",
					// 							color: "#fff",
					// 							marginBottom: "0rem !important",
					// 						}}>
					// 						<AccordionSummary
					// 							sx={{
					// 								padding: "0 1rem",
					// 								"& .MuiAccordionSummary-content": {
					// 									margin: "0",
					// 								},
					// 								"& .MuiAccordionSummary-root": {
					// 									minHeight: "fit-content",
					// 								},
					// 							}}
					// 							expandIcon={
					// 								<ExpandMoreIcon sx={{ color: "#fff" }} />
					// 							}
					// 							aria-controls='panel1bh-content'
					// 							id='panel1bh-header'>
					// 							<ListItemText primary={noteData?.title} />
					// 						</AccordionSummary>
					// 						<AccordionDetails>
					// 							<Typography color='white'>
					// 								{noteData?.note}
					// 							</Typography>
					// 						</AccordionDetails>
					// 					</Accordion>

					// 					{/* <ListItemText>{noteData?.["title"]}</ListItemText> */}
					// 					<ListItemIcon
					// 						sx={{ minWidth: "0rem !important" }}
					// 						onClick={(e) => {
					// 							handleClick(e);
					// 						}}>
					// 						<MoreVertIcon
					// 							fontSize='small'
					// 							sx={{ color: "#fff", cursor: "pointer" }}
					// 						/>
					// 					</ListItemIcon>
					// 					<Menu
					// 						id='basic-menu'
					// 						anchorEl={anchorEl}
					// 						open={open}
					// 						onClose={handleCloseMenu}
					// 						sx={{
					// 							"& .MuiPaper-root": {
					// 								backgroundColor: "#1B1B1B", // Background color of the entire menu
					// 							},
					// 						}}
					// 						MenuListProps={{
					// 							"aria-labelledby": "basic-button",
					// 						}}>
					// 						<MenuItem
					// 							sx={{
					// 								color: "#fff", // White text
					// 								backgroundColor: "#1B1B1B", // Menu item background
					// 								"&:hover": {
					// 									backgroundColor: "#555", // Darker grey on hover
					// 								},
					// 							}}
					// 							onClick={handleCloseMenu}>
					// 							Edit
					// 						</MenuItem>
					// 						<MenuItem
					// 							sx={{
					// 								color: "#fff", // White text
					// 								backgroundColor: "#1B1B1B", // Menu item background
					// 								"&:hover": {
					// 									backgroundColor: "#555", // Darker grey on hover
					// 								},
					// 							}}
					// 							onClick={() => {
					// 								deleteNoteHandler(noteId);
					// 								handleCloseMenu();
					// 							}}>
					// 							Delete
					// 						</MenuItem>
					// 					</Menu>
					// 				</ListItem>
					// 				<Divider sx={{ backgroundColor: "#fff" }} />
					// 			</React.Fragment>
					// 		);
					// 	})}
					// </List>
					NoteScreen()
				)}
				<Divider sx={{ backgroundColor: "#fff" }} />
				{/* <List sx={{ backgroundColor: "#000000" }}>
					<ListItem sx={{ display: "flex", flexDirection: "column" }}>
						<ListItemText sx={{ textAlign: "start", width: "100%" }}>
							{firstName} {lastName}
						</ListItemText>
						<input
							ref={inputRef}
							type='text'
							style={{ width: "100%", "margin-top": "0.5rem", borderRadius: "5px" }}
							placeholder={"Note Title"}
						/>
						<textarea
							ref={textAreaRef}
							rows='4'
							// cols='50'
							style={{
								width: "100%",
								"margin-top": "0.5rem",
								borderRadius: "5px",
							}}
							placeholder={"Add Note"}
							type='text'
						/>
						<Box
							sx={{
								display: "flex",
								flexDirection: "row",
								gap: "0.5rem",
								justifyContent: "flex-end",
								width: "100%",
								paddingTop: "0.5rem",
							}}>
							<Button size='small' sx={{ color: "#fff" }}>
								Cancel
							</Button>
							<Button
								variant='contained'
								onClick={saveNewNote}
								size='small'
								sx={{ backgroundColor: "#FCCB06" }}>
								Save
							</Button>
						</Box>
					</ListItem>
				</List> */}
				{newNoteScreen === "Notes" && (
					<Box
						sx={{
							display: "flex",
							flexDirection: "row",
							gap: "0.5rem",
							justifyContent: "flex-end",
							width: "100%",
							padding: "1rem 1rem",
						}}>
						<Button
							variant='contained'
							onClick={() => setNewNoteScreen("Create New Note")}
							size='small'
							sx={{ backgroundColor: "#FCCB06" }}>
							Create New
						</Button>
					</Box>
				)}
			</Paper>
		</>
	);
};

export default NotesMenu;
